import React from 'react';

import SelectAllCheckbox from './select_all_checkbox';

import type { Props } from './types';

export default function MapListHeaderLiteCrm({ selectionCount, ...props }: Props) {
  return  (
    <div className="header-row">
      <SelectAllCheckbox {...props} />
      <span className="header-title">Property Name / Address </span>
      <span className="selected-count text-muted">
        {selectionCount} selected
      </span>
    </div>
  );
}
